import { Badge, Box, Button, IconButton } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { TOOLBAR_ACTIONS } from "../config/TOOLBAR_ACTIONS";
import { TABLE_VARIANTS } from "../config/TABLE_VARIANTS";

const BottomToolBar = ({ variant, onAction, contadorDeNotas }) => {
  const isComplete = variant === TABLE_VARIANTS.COMPLETO;
  return (
    isComplete && (
      <Box sx={{ display: "flex", gap: 2, p: 1 }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => onAction({ type: TOOLBAR_ACTIONS.EXPORTAR_EXCEL })}
          startIcon={<TableChartIcon />}
        >
          Exportar Excel
        </Button>

        <Button
          variant="contained"
          color="error"
          onClick={() => onAction({ type: TOOLBAR_ACTIONS.EXPORTAR_PDF })}
          startIcon={<PictureAsPdfIcon />}
        >
          Exportar PDF
        </Button>
        <Badge
          badgeContent={contadorDeNotas}
          color="error"
          overlap="circular"
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <IconButton
            onClick={() => onAction({ type: TOOLBAR_ACTIONS.ABRIR_NOTAS })}
            sx={{
              color: "#f4b400", // Amarillo Google
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "rgba(244,180,0,0.08)",
              },
            }}
          >
            <StickyNote2Icon sx={{ fontSize: 28 }} />
          </IconButton>
        </Badge>
      </Box>
    )
  );
};

export default BottomToolBar;
